import { useQuery } from '@tanstack/react-query';
import { StrainIndexReportService } from '@/infra/services/strain-index-report';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GetStrainIndexParams {
	organization_id: string;
	company_id: string;
	id: string;
}

const Service = StrainIndexReportService.getInstance();

export const useGetStrainIndex = (params: GetStrainIndexParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_STRAIN_INDEX_REPORT, params],
		queryFn: () => Service.getReport(params),
		enabled: !!params.organization_id && !!params.company_id && !!params.id,
		retry: 0
	});
};
